import React from 'react';
import Button from '../../../components/ui/Button';
import AppIcon from '../../../components/AppIcon';

export default function EnquirySuccessModal({ isOpen, onClose, enquiryId }) {
  if (!isOpen) return null;

  const handleViewEnquiry = () => {
    // Navigate to enquiry detail page
    window.location.href = `/customer-dashboard`;
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-40"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card rounded-2xl shadow-elevated border border-border max-w-md w-full p-8 animate-in fade-in zoom-in duration-200">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
              <AppIcon name="CheckCircle" size={32} className="text-green-600" />
            </div>
          </div>

          {/* Title */}
          <h2 className="text-2xl font-bold text-foreground text-center mb-4">
            Enquiry Submitted Successfully
          </h2>

          {/* Message */}
          <p className="text-muted-foreground text-center mb-8 leading-relaxed">
            Thank you for submitting your enquiry. Your request has now been sent to travel agents who specialise in the trip you're looking for. Agents may reach out with questions or quotes. We'll notify you when they do.
          </p>

          {/* CTA Button */}
          <Button
            variant="default"
            onClick={handleViewEnquiry}
            className="w-full"
            size="lg"
          >
            View my enquiry
          </Button>
        </div>
      </div>
    </>
  );
}